import {
  ConversionResponse,
  IConversion,
} from 'src/pages/settings/conversions/conversions/store/type'

export const conversionResponseToConversion = (
  response: ConversionResponse
): IConversion => ({ id: response.id, ...response })
